import { supabase } from '../../client';
import { BlacklistEntry } from '../types/blacklist';

const PAGE_SIZE = 1000;

/**
 * 해당 사용자의 거파 명단 전체를 조회합니다. (RLS + 명시 user_id 필터 이중화)
 * PostgREST 기본 1000행 상한으로 인한 조용한 절단을 막기 위해 페이지 순회한다.
 * (created_at 동률 대비 id 보조 정렬 = 페이지 경계 안정성.
 *  명시 .eq('user_id')는 페이지 사이 세션 토큰이 다른 계정으로 바뀌는 극단 창에서
 *  타 계정 행이 섞이는 것을 차단하는 defense in depth)
 */
export async function findAllOwn(userId: string): Promise<BlacklistEntry[]> {
  const all: BlacklistEntry[] = [];
  for (let from = 0; ; from += PAGE_SIZE) {
    const { data, error } = await supabase
      .from('blacklist')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .order('id', { ascending: false })
      .range(from, from + PAGE_SIZE - 1);

    if (error) throw error;
    const page = data ?? [];
    all.push(...page);
    if (page.length < PAGE_SIZE) break;
  }
  return all;
}

/**
 * 등록/재등록합니다. (UNIQUE(user_id, nickname) upsert — 재등록 = 사유 갱신)
 */
export async function upsertEntry(userId: string, nickname: string, reason: string | null): Promise<BlacklistEntry> {
  const { data, error } = await supabase
    .from('blacklist')
    .upsert({ user_id: userId, nickname, reason }, { onConflict: 'user_id,nickname' })
    .select()
    .single();

  if (error) throw error;
  return data;
}

/**
 * 닉네임 기준으로 해제합니다. (UNIQUE 제약이라 닉네임당 최대 1행)
 */
export async function removeByNickname(userId: string, nickname: string): Promise<void> {
  const { error } = await supabase
    .from('blacklist')
    .delete()
    .eq('user_id', userId)
    .eq('nickname', nickname);

  if (error) throw error;
}
